// namespace SPA
// {
// 	export namespace Contacts
// 	{
// 		export class Form
// 		{

// 			private Modal: JQuery | null;

// 			private ObjectList: SPA.Realtor.ObjectList;

// 			public constructor(company: Wollmilch.CompanyObject, modal: JQuery | null = null)
// 			{
// 				// this.searchbar = new InputField('text', { value: '', name: 'address.search', placeholder: 'Adressbuch durchsuchen' });
// 				// this.addbtn = new HTMLButtonElement();

// 				this.content = this.setContent();
// 				this.ObjectList = app.getObjectManager().getList();
// 				this.Modal = null;
// 			}

// 			public getContent(): JQuery<HTMLElement>
// 			{
// 				return this.content;
// 			}

// 			public getObjectList()
// 			{
// 				return this.ObjectList;
// 			}

// 			public buildTable(): JQuery<HTMLElement> {
// 				const content =
// 					ui.$$.div().addClass('row')
// 						.append(ui.$$.div().addClass('col-xs-6')
// 							.append('<input class="form-control" type="text" name="address.search" data-type="bidder" placeholder="Adressbuch durchsuchen" />')
// 						)
// 						.append(ui.$$.div().addClass('col-xs-6')
// 							.append('<button class="btn btn-primary" id="addressNew" type="button">Neue Adresse anlegen</button>')
// 						);

// 				const table = $('<table class="table table-striped table-condensed table-hover">')
// 					.append($('<thead>').append($('<tr>')
// 						.append('<th>KdNr</th>')
// 						.append('<th>Zuordnung(en)</th>')
// 						.append('<th>Kontakt</th>')
// 						.append('<th>Anschrift</th>')
// 						.append('<th>E-Mail</th>')
// 						.append('<th>Mobil</th>')
// 						.append('<th>Telefon</th>')
// 					))
// 					.append($('<tbody>'));

// 				return $(content).add(table);
// 			}

// 			private getTableData()
// 			{
// 				const entries: any = new Array();
// 				const contacts = app.getAuthenticationManager().getContacts();

// 				for (const id in contacts)
// 				{
// 					const address = contacts[id].data;
// 					const types = contacts[id].types;

// 					const typeList = [];
// 					for (const x in types) {
// 						typeList.push(x);
// 					}

// 					entries.push([
// 						id,
// 						typeList.join(', '),
// 						address.salutation + ' ' + address.title + ' ' + address.name + ' ' + address.surname,
// 						address.street + ' ' + address.housenumber + ', ' + address.postalcode + ' ' + address.city + ' (' + address.state + ', ' + address.country + ')',
// 						address.phone,
// 						address.mobile,
// 						address.email
// 					]);
// 				}

// 				return entries;
// 			}
// 		}
// 	}
// }
